import React, {useEffect, useState} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import {connect} from "react-redux";
import styled, {css} from "styled-components";
import * as TagManager from "react-gtm-module";
import {_hideModal, _hideSpinner, _showModal, _showSpinner} from "../../store/system/service";
import {_getUser, _resetPassword} from "../../store/user/service";
import FieldWrapper from "../custom/field-wrapper";
import Header from "../custom/header";
import QnectTextField from "../qnect-ui/qnect-text-field";
import QnectButton from "../qnect-ui/qnect-button";
import useConfig from "../../utils/qnect-config";
import {StyledModalDiv} from "../login/login-style";
import {useHistory} from "react-router-dom";
import zxcvbn from "zxcvbn";

const useStyles = makeStyles(theme => ({
    wrapper: {
        width: "100%",
        background: "rgb(246,248,250)",
        minHeight: "calc(100vh - 64px)",
        '& .MuiFormControl-root.TextField' : {
            marginBottom: '10px',
            marginTop: '10px',
        },
        [theme.breakpoints.down("sm")]: {
            minHeight: "calc(100vh + 28px)",
        },
        [theme.breakpoints.up("lg")]: {}
    },
    topBg: {
        width: "100%",
        backgroundColor: "#FFFFFF",
        [theme.breakpoints.down("sm")]: {},
        [theme.breakpoints.up("lg")]: {
            height: "432px"
        }
    },
    topRow: {
        margin: "0 auto",
        width: "100%",
        maxWidth: "1440px",
        display: "flex",
        justifyContent: "space-between",
        [theme.breakpoints.down("sm")]: {
            height: "44px",
            padding: "0 12px",
            alignItems: "center",
            borderBottom: "1px solid #E1E4E8"
        },
        [theme.breakpoints.up("lg")]: {
            alignItems: "flex-end",
            height: "75px"
        }
    },
    logo: {
        [theme.breakpoints.down("sm")]: {
            width: "70px"
        },
        [theme.breakpoints.up("lg")]: {
            width: "122px",
            height: "35px"
        }
    },
    main: {
        backgroundColor: "#FFFFFF",
        boxShadow: "0 4px 4px 0 rgba(0,0,0,0.04)",
        [theme.breakpoints.down("sm")]: {
            margin: "20px auto",
            padding: "20px 16px",
            height: "454px",
            width: "92%"
        },
        [theme.breakpoints.up("lg")]: {
            margin: "0 auto",
            padding: "48px 70px",
            height: "fit-content",
            width: "600px"
        },
        fontFamily: "Inter-Regular",
        fontSize: "16px",
    },
    title: {
        fontFamily: "Stag-Medium",
        fontSize: "24px",
        fontWeight: "500",
        letterSpacing: "0",
        lineHeight: "28px",
        textAlign: "center",
        [theme.breakpoints.down("sm")]: {
            marginBottom: "0px",
            color: "#003DA5",
            fontSize: "21px"
        },
        [theme.breakpoints.up("lg")]: {
            marginBottom: "57px",
            color: "#003DA5"
        }
    },
    message: {
        color: "#0A1F44",
        fontFamily: "Inter",
        letterSpacing: "0",
        textAlign: "center",
        lineHeight: "24px",
        [theme.breakpoints.down("sm")]: {
            fontSize: "12px",
            lineHeight: "normal",
            "&:last-child": {
                marginTop: "4px"
            }
        },
        [theme.breakpoints.up("lg")]: {
            fontSize: "18px",
            "&:last-child": {
                marginTop: "37px"
            }
        }
    },
    image: {
        textAlign: "center",
        [theme.breakpoints.down("sm")]: {
            "& svg": {
                width: "260px"
            }
        },

    },
    outerTitle: {
        [theme.breakpoints.down("sm")]: {
            margin: "20px auto",
            padding: "20px 16px",
            height: "454px",
            width: "92%",
        },
        [theme.breakpoints.up("lg")]: {
            margin: "0 auto",
            width: "600px",
            height: '88px',
        },
        position: "relative",
        top: "0",
        textAlign: "center",
        fontFamily: "Stag-Medium",
        fontSize: "24px",
        backgroundColor: '#f1f2f4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderTop: '2px solid #009AE4'
    },
    firstLine: {
        marginBottom: "17px",
        textAlign: "center",
        fontSize: "18px",
        fontWeight: "bold",
        lineHeight: '28px',
    },
}));

const RequirementsDiv = styled.div`
    margin-bottom: 20px;

    ul {
        padding-left: 32px;
    }
    
    li {
        padding-top: 8px;
    }
`;

const StyledList = styled.li`
    padding-left: 7px;
    margin-left: -7px; 
    
    ${({passed, cond2Status}) => {
        if (passed) {
            return css`
                        list-style-type:  '✓'; 
                        color: #009AE4;
                    `
        } else {
            if (cond2Status) {
                return css`
                        list-style-type:  disc;   
                        opacity: 30%;
                        margin-left: 2px;
                    `
            } else {
                return css`
                        list-style-type:  '✖';   
                        color: #D54040;
                    `
            }
            
        }
    }}
`;

const PasswordInputsDiv = styled.div`
    padding: 0 45px;
`;

const SavePasswordDiv = styled.div`
    text-align: center;
    button {
        border-radius: 27px;
        height: 52px;
        padding: 0 27px;
        margin-top: 20px;
    }
`

const StyledModalDiv2 = styled(StyledModalDiv)`
    padding-top: 32.2px;
    width: 600px;
    height: 257px;
    .title {
        margin-bottom: 40px;
    }
    
    div.content {
        margin-bottom: 40px;
    }
    
    div.buttonDiv {
        margin: 0 auto;
        
        button {
            width: 180px;
        }
    }

`;

const ResetPassword = ({props, passwordMinLength, passwordLimit}) => {

    const classes = useStyles();
    const history = useHistory();
    const cfg = useConfig();

    const [cond1, setCond1] = useState(false);
    const [cond2, setCond2] = useState(false);
    const [cond3, setCond3] = useState(false);
    const [cond4, setCond4] = useState(false);
    const [cond5, setCond5] = useState(false);
    const [cond6, setCond6] = useState(false);
    const [cond7, setCond7] = useState(false); // if password contains username
    const [isConfirmPasswordValid, setIsConfirmPasswordValid] = useState(false);

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordErrorMessage, setPasswordErrorMessage] = useState('');
    const [confirmPasswordErrorMessage, setConfirmPasswordErrorMessage] = useState('');
    useEffect(() => {
        if (password.length >= passwordMinLength) {
            setCond1(true);
        } else {
            setCond1(false);
        }

        let usernameWithoutDomain = props.user.email.split("@") ? props.user.email.split("@")[0] : props.user.email;
        if(password.toLowerCase().includes(usernameWithoutDomain.toLowerCase()) || isCommonPassword(password)) {
            setCond7(false);
        } else {
            setCond7(true);
        }

        let cond2Checker = 0;

        if (password.match(/[a-z]/g)){
            cond2Checker++;
            setCond3(true);
        } else {
            setCond3(false);
        }

        if (password.match(/[A-Z]/g)){
            cond2Checker++;
            setCond4(true);
        } else {
            setCond4(false);
        }

        if (password.match(/\d/g)){
            cond2Checker++;
            setCond5(true);
        } else {
            setCond5(false);
        }

        if (password.match(/((?=.*[!@#$%&*()_+=|<>?{}\[\]~-]).+$)/g)){
            cond2Checker++;
            setCond6(true);
        } else {
            setCond6(false);
        }

        if (cond2Checker > 2) {
            setCond2(true);
        } else {
            setCond2(false);
        }

        // confirmPassword validation
        let confirmPasswordValidCount = 0;

        if (confirmPassword.match(/[a-z]/g)) {
            confirmPasswordValidCount++;
        }

        if (confirmPassword.match(/[A-Z]/g)){
            confirmPasswordValidCount++;
        }

        if (confirmPassword.match(/\d/g)){
            confirmPasswordValidCount++;
        }

        if (confirmPassword.match(/((?=.*[!@#$%&*()_+=|<>?{}\[\]~-]).+$)/g)){
            confirmPasswordValidCount++;
        }

        if (confirmPassword.length >= 8 && confirmPasswordValidCount >= 2) {
            setIsConfirmPasswordValid(true);
        } else {
            setIsConfirmPasswordValid(false);
        }
    }, [password, confirmPassword]);


    const handleResetPasswordSubmit = () => {
        if (password != confirmPassword) {
            setPasswordErrorMessage(cfg('resetPassword.errorMessages.passwordNotMatch'));
            setConfirmPasswordErrorMessage(cfg('resetPassword.errorMessages.passwordNotMatch'));
            return;
        }

        props.showSpinner();
        props.resetPassword(props.user.email, password).then((resp) => {
            if (resp === 'SUCCESS') {
                TagManager.dataLayer({
                    dataLayer: {
                        event: 'popup',
                        popupPath: '/resetPassword',
                        popupTitle: 'Forgot Password'
                    }
                });
                props.showModal({
                    flat: true,
                    content: <StyledModalDiv2>
                        <div className="title"
                             style={props.lang === 'zh' ? {fontWeight: "bold"} : {}}>
                            {cfg('forgotPassword.setPassword')}
                        </div>
                        <div className="content">{cfg('forgotPassword.resetPwMessage')}</div>
                        <div className="buttonDiv">
                            <QnectButton
                                onClick={() => {
                                    props.hideModal();
                                    history.push('/login');
                                }}
                                field="close"
                            ></QnectButton>
                        </div>
                    </StyledModalDiv2>,
                    disableBackDropClick: true
                })
            } else if (resp === 'FAILED') {
                setPasswordErrorMessage(cfg('resetPassword.errorMessages.notLastPassword') + passwordLimit + cfg('resetPassword.errorMessages.notLastPassword_1'));
                setConfirmPasswordErrorMessage(cfg('resetPassword.errorMessages.notLastPassword') + passwordLimit + cfg('resetPassword.errorMessages.notLastPassword_1'));
            } else if (resp == "Invalid password format") {
                setPasswordErrorMessage(resp);
                setConfirmPasswordErrorMessage(resp);
            }
            props.hideSpinner();
        }, (error) => {
            if (error.response.status === 500 || error.response.status === 400 || error.response.status === 404) {
                setPasswordErrorMessage(cfg('errorMessage.serverError'));
                setConfirmPasswordErrorMessage(cfg("errorMessage.serverError"));
            } else {
                setPasswordErrorMessage(error.response.statusText);
                setConfirmPasswordErrorMessage(error.response.statusText);
            }
            props.hideSpinner();
        });
    }

    const isCommonPassword = (password) => {
        var isCommonPass = true;
        var result=zxcvbn(password);

        if(result.score>=2){
            isCommonPass = false;
        }
        return isCommonPass;
    }

    return (
        <div className={classes.wrapper}>
            <Header />

            <div style={{marginTop: '60px'}}>
                <div className={classes.outerTitle} style={props.lang === 'zh' ? {fontWeight: "bold"} : {}}>
                    {cfg("forgotPassword.setPassword")}
                </div>
                <div className={classes.main}>
                    <RequirementsDiv>
                        <div className={classes.firstLine}>{cfg("forgotPassword.lastPassUsed") + passwordLimit + cfg("forgotPassword.lastPassUsed_1")}</div>
                        <ul>
                            <StyledList passed={cond1}>{cfg("forgotPassword.minLength") + passwordMinLength + cfg("forgotPassword.minLength2")}</StyledList>
                            <StyledList passed={cond7}>{cfg("forgotPassword.notCommon")}</StyledList>
                            <StyledList passed={cond2}>{cfg("forgotPassword.haveAtleast3CharTypes")}</StyledList>
                            <ul>
                                <StyledList passed={cond3} cond2Status={cond2}>{cfg("forgotPassword.aLowerCase")}</StyledList>
                                <StyledList passed={cond4} cond2Status={cond2}>{cfg("forgotPassword.anUpperCase")}</StyledList>
                                <StyledList passed={cond5} cond2Status={cond2}>{cfg("forgotPassword.aNumeric")}</StyledList>
                                <StyledList passed={cond6} cond2Status={cond2}>{cfg("forgotPassword.aSpecial")}</StyledList>
                            </ul>
                        </ul>
                    </RequirementsDiv>
                    <PasswordInputsDiv>
                        <FieldWrapper>
                            <QnectTextField
                                field="resetPasswordNewPW"
                                type="password"
                                errorMessage={passwordErrorMessage}
                                onChange={(evt) => {
                                    setPassword(evt.target.value);
                                    setPasswordErrorMessage('');
                                }}
                            />
                        </FieldWrapper>
                        <FieldWrapper>
                            <QnectTextField
                                field="resetPasswordVerifyNewPW"
                                type="password"
                                errorMessage={confirmPasswordErrorMessage}
                                onChange={(evt) => {
                                    setConfirmPassword(evt.target.value);
                                    setConfirmPasswordErrorMessage('');
                                }}
                            />
                        </FieldWrapper>
                    </PasswordInputsDiv>
                    <SavePasswordDiv>
                        <FieldWrapper>
                            <QnectButton
                                field="resetPassword"
                                onClick={handleResetPasswordSubmit}
                                disabled={ !cond1 || !cond2 || !cond7 || !isConfirmPasswordValid }
                            />
                        </FieldWrapper>
                    </SavePasswordDiv>
                </div>
            </div>

        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        user: _getUser(state)
    }
}

const mapDispatchToProps = {
    showSpinner: _showSpinner,
    hideSpinner: _hideSpinner,
    resetPassword: _resetPassword,
    showModal: _showModal,
    hideModal: _hideModal
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
